/**
 * Task actions enum
 * Represents the different types of actions that can be performed on tasks
 */
export enum ACTIONS {
    APPROVE_REJECT = 'APPROVE_REJECT',
    DOWNLOAD = 'DOWNLOAD',
    UPLOAD = 'UPLOAD',
    COMMENT = 'COMMENT',
    REQUEST = 'REQUEST',
    ADJUST = 'ADJUST',
    REVISE = 'REVISE',
    REMIND = 'REMIND',
    PRESENT = 'PRESENT',
    REVIEW = 'REVIEW'
}

/**
 * Formats an ACTIONS enum value into a human-readable string
 * @param action - The ACTIONS enum value to format
 * @returns A formatted string representation of the action
 */
export function formatAction(action: ACTIONS): string {
    switch (action) {
        case ACTIONS.APPROVE_REJECT:
            return 'Approve or Reject';
        case ACTIONS.DOWNLOAD:
            return 'Download';
        case ACTIONS.UPLOAD:
            return 'Upload';
        case ACTIONS.COMMENT:
            return 'Comment';
        case ACTIONS.REQUEST:
            return 'Request';
        case ACTIONS.ADJUST:
            return 'Adjust';
        case ACTIONS.REVISE:
            return 'Revise';
        case ACTIONS.REMIND:
            return 'Remind';
        case ACTIONS.PRESENT:
            return 'Present';
        case ACTIONS.REVIEW:
            return 'Review';
        default:
            return action;
    }
}